import ChannelCard from "../../Utilities/ChannelCard";
import logoTikTokAds from "../../../../../images/logos/logo_tiktokads.svg";
import useTikTokAdsSetup from "./useTikTokAdsSetup";

export default function TikTokAdsProvider() {
    const { initiateTikTokSetup } = useTikTokAdsSetup({ callbackPath: '/tiktok/accounts' })

    return(
        <ChannelCard
            icon={logoTikTokAds}
            label={'TikTok Ads'}
            description={'Reply to comments on your TikTok Ads to boost conversions and protect your brand'}
            onClick={initiateTikTokSetup}
        />
    )
}